<template>
  <v-dialog v-model="computedDialogUnauthorized" max-width="500px">
    <v-card>
      <v-card-title>
        <span>Unauthorized.</span>
      </v-card-title>
      <v-card-actions>
        <v-btn color="success" flat @click.stop="methodUiDialogsUnauthorized()"
          >Ok</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  computed: {
    computedDialogUnauthorized() {
      return this.$store.state.ui.dialogs.unauthorized;
    }
  },
  methods: {
    methodUiDialogsUnauthorized() {
      this.$store.commit("mutationDialogUi", {
        dialog: "unauthorized"
      });
    }
  }
};
</script>
